import { useEffect, useState } from "react";

import layout from "@app/styles/layout";

export const WIDE_DESKTOP_QUERY = `(min-width: ${layout.breakpointWideDesktop}px)`;
export const DESKTOP_QUERY = `(min-width: ${layout.breakpointDesktop}px) and (max-width: ${
  layout.breakpointWideDesktop - 1
}px)`;
export const NOT_DESKTOP_QUERY = `(max-width: ${layout.breakpointDesktop - 1}px)`;
export const TABLET_QUERY = `(min-width: ${layout.breakpointTablet}px) and (max-width: ${
  layout.breakpointDesktop - 1
}px)`;
export const TABLET_VERTICAL_QUERY = `(min-width: ${layout.breakpointTabletPortrait}px) and (orientation: portrait)`;
export const MOBILE_QUERY = `(max-width: ${layout.breakpointTablet - 1}px)`;

/*
 * useMedia returns true if given query is matched and false otherwise
 * e.g.: useMedia('(min-width: 40rem)', false) or useMedia('(orientation: portrait)')
 */
export default function useMedia(mediaQuery: string, defaultValue: boolean = false): boolean {
  const initialMatches =
    typeof window !== "undefined" ? window.matchMedia(mediaQuery).matches : defaultValue;

  const [matches, setMatches] = useState<boolean>(initialMatches);

  useEffect(() => {
    let active = true;
    // Create a MediaQueryList (https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList)
    const mql = window.matchMedia(mediaQuery);

    // Create a listener that updates the state
    const onchange = () => {
      // Prevent updating an unmounted component
      if (!active) {
        return;
      }
      // Set the state
      setMatches(mql.matches);
    };

    // Attach the listener to the MediaQueryList
    if (mql.addEventListener) {
      mql.addEventListener("change", onchange);
    } else {
      // Use the deprecated addListener on browsers that do not have
      // support for addEventListener. (eg. Safari)
      mql.addListener(onchange);
    }

    // Set the initial state
    setMatches(mql.matches);

    return () => {
      active = false;

      if (mql.removeEventListener) {
        mql.removeEventListener("change", onchange);
      } else {
        mql.removeListener(onchange);
      }
    };
  }, [mediaQuery]);

  return matches;
}
